export enum ButtonTheme {
  // Transparent
  GrayTransparent = 'grayTransparent',
  // With background
  PrimarySmall = 'primarySmall',
  PrimaryBig = 'primaryBig',
  SecondaryTransparentSmall = 'SecondaryTransparentSmall',
  SecondaryTransparentBig = 'SecondaryTransparentBig',
  SecondarySolidSmall = 'secondarySolidSmall',
  SecondarySolidBig = 'secondarySolidBig',
}
